import { Component, type ErrorInfo, type ReactNode } from 'react'

import { ChartPlaceholder } from './ChartPlaceholder'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ChartErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
    console.error('Chart loading error:', error)
  }

  public render() {
    if (this.state.hasError) {
      return <ChartErrorFallback />
    }

    return this.props.children
  }
}

const ChartErrorFallback = () => {
  return <ChartPlaceholder status="error" />
}
